import replaceCartContent from '../../../cart/replaceCartContent';
let memberUpdateHandled = false;

function shouldDisableMemberFreeShipping() {
  const raw = localStorage.getItem('ig-vars');
  if (!raw) return false;

  try {
    const vars = JSON.parse(raw);

    const FREE_SHIPPING_TEST_ID = '54bb9587f2de';
    const DISABLE_FS_VARIANT_ID = 'f0eed5a17048';
    const activeVariantId = vars[FREE_SHIPPING_TEST_ID];

    // Only disable if no free shipping variant
    return DISABLE_FS_VARIANT_ID === activeVariantId;
  } catch (e) {
    console.error('Error parsing ig-vars:', e);
    return false;
  }
}

async function handleMemberCart(e) {
  if (e) {
    if (e?.type === 'member-updated') {
      if (memberUpdateHandled) return;
      memberUpdateHandled = true;
    }
  }
  const body = document.querySelector('body');
  const { attributes } = await Shopify.functions.getCart();
  const isLoggedIn = body.dataset.loggedIn === 'true';
  const isAlreadyMember = attributes["_is_club_member"] === 'true' || attributes["_is_club_member"] === true;

  // drive the flag from Intelligems variant for A/B testing
  const disableFS = shouldDisableMemberFreeShipping();
  attributes["disable_member_free_shipping"] = disableFS ? 'true' : 'false';


  if (isLoggedIn && !isAlreadyMember) {
    attributes["_is_club_member"] = 'true';
  } else if (!isLoggedIn && isAlreadyMember) {
    attributes["_is_club_member"] = 'false';
  }

  await Shopify.functions.updateCartAttributes(attributes);
  return setTimeout(replaceCartContent);
}

handleMemberCart();
document.addEventListener('member-updated', (e) => handleMemberCart(e));
document.addEventListener('member-updated__from-toggle', (e) => handleMemberCart(e));